import { combineReducers } from 'redux';
import user from './user';
import report from './report';

const reducers = combineReducers({
    user, report
});
export default reducers;